import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaskPiiDirective } from '../../directives/mask-pii/mask-pii.directive';
import { ButtonColor, ButtonSize, ButtonWrapper, FeedbackModule } from '../../elements';
import { ModalConfig } from './modal.config';

@Component({
  selector: 'mds-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FeedbackModule, MatDialogModule, MaskPiiDirective],
})
export class ModalComponent implements OnInit {
  public dialogRef = inject<MatDialogRef<ModalComponent>>(MatDialogRef);
  private modalData = inject<ModalConfig>(MAT_DIALOG_DATA);

  config: ModalConfig;

  primaryConfig!: ButtonWrapper;
  secondaryConfig!: ButtonWrapper;
  tertiaryConfig!: ButtonWrapper;
  isLoading = false;

  @Output() handleTertiaryClick = new EventEmitter<void>();
  @Output() confirm$ = new EventEmitter<void>();

  constructor() {
    this.config = { ...this.modalData };
  }

  ngOnInit(): void {
    if (this.config) {
      this.setModal();
    }
  }

  cancel() {
    this.dialogRef.close({ confirm: false, dismiss: true });
  }

  confirm() {
    if (this.config.showLoadingOnConfirm) {
      // in this mode: devs can listen to `confirm$` to trigger an action
      // they will also need to close the modal manually when the action is done
      // in the meantime the modal will be in loading-state and impossible to close
      this.dialogRef.disableClose = true;
      this.isLoading = true;
      this.confirm$.next();
    } else {
      this.dialogRef.close({ confirm: true });
    }
  }

  private setModal(): void {
    if (this.config.primaryLabel) {
      this.primaryConfig = {
        config: {
          size: ButtonSize.Medium,
          color: this.config.primaryColor ?? ButtonColor.Primary,
        },
        content: {
          label: this.config.primaryLabel,
        },
      };
    }

    if (this.config.secondaryLabel) {
      this.secondaryConfig = {
        config: {
          size: ButtonSize.Medium,
          color: ButtonColor.Secondary,
        },
        content: {
          label: this.config.secondaryLabel,
        },
      };
    }

    if (this.config.tertiaryLabel) {
      this.tertiaryConfig = {
        config: {
          size: ButtonSize.Medium,
          color: ButtonColor.Tertiary,
        },
        content: {
          label: this.config.tertiaryLabel,
        },
      };
    }
  }
}
